import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';
import {
    AppBar,
    Button,
    Card,
    CardContent,
    Icon,
    Toolbar,
    Typography
} from '@material-ui/core';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ReduxUseRecord from "../../../../store/actionreducers/useRecord";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxMissionType from "../../../../store/actionreducers/missionPriceType";
import MissionConfigsDialog from './MissionConfigsDialog';


class MissionConfigsPage extends Component {

    state = {
        value: 0
    };

    handleChange = (event, value) => {
        this.setState({value});
    };

    async componentDidMount() {
        try {
            await this.props.getMissionPriceTypes();
            await this.props.getUseRecordBasicSettings();
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    render() {
        const {classes, openEditDataDialog} = this.props;

        const basicSettings = this.props.basicSettings.map((setting) => {
            const mission_type = this.props.missionTypes.find((missionType) => {
                return missionType.id === setting.fk_mission_type_id;
            });
            return {...setting, mission_type};
        });

        // FusePageSimple 的 sidebarInner 屬性 , 會將 header 貼齊父 component
        return (
            <React.Fragment>
                <FusePageSimple
                    sidebarInner
                    classes={{
                        contentCardWrapper: classes.layoutContentCardWrapper,
                    }}
                    header={
                        <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">
                            <div className="flex flex-1 items-center">
                                <div className="flex items-center">
                                    <FuseAnimate animation="transition.expandIn" delay={300}>
                                        <Icon className="text-32 mr-12">settings</Icon>
                                    </FuseAnimate>
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <Typography variant="title">APP服務設定</Typography>
                                    </FuseAnimate>
                                </div>
                            </div>
                        </div>
                    }
                    content={
                        <Card>
                            <AppBar position="static" elevation={0}>
                                <Toolbar className="pl-16 pr-8">
                                    <Typography variant="subheading" color="inherit" className="flex-1">
                                        APP服務相關設定
                                    </Typography>
                                </Toolbar>
                            </AppBar>

                            <CardContent>

                                {
                                    basicSettings.map((basicSetting) => {
                                        if (!basicSetting.mission_type) return '';
                                        else return (
                                            <div key={`basicSetting-${basicSetting.id}`} className="mb-24">
                                                <Typography className="font-bold mb-4 text-15">
                                                    {basicSetting.mission_type.name}
                                                </Typography>
                                                <Typography> {basicSetting.min} 分鐘一次 </Typography>
                                            </div>
                                        );
                                    })
                                }

                                <Button variant="contained" color="secondary"
                                        onClick={openEditDataDialog}>
                                    修改
                                </Button>
                            </CardContent>
                        </Card>
                    }
                />
                <MissionConfigsDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    layoutContentCardWrapper: {
        padding: 24
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openEditDataDialog: ReduxGlobal.ActionCreator.openEditDataDialog,
        getUseRecordBasicSettings: ReduxUseRecord.ActionCreator.getUseRecordBasicSettings,
        getMissionPriceTypes: ReduxMissionType.ActionCreator.getMissionPriceTypes,
    }, dispatch);
}


function mapStateToProps({auth, useRecord: {basicSettings}, missionType}) {
    return {
        user: auth.user,
        basicSettings,
        missionTypes: missionType.list
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(MissionConfigsPage));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/missionConfig/MissionConfigsPage.js